<div *ngIf="loading" [ngStyle]="{ width: '100%', height: '100%' }">
	<shakespeare-spinning-loader [rotating]="true"></shakespeare-spinning-loader>
</div>
